export default __webpack_public_path__ + "static/media/template-img-3-large.8c6d3736.jpg";